import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import parse from "html-react-parser";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {}

interface OwnProps extends WidgetProps {}

export interface CountryZoneStyles {
    container: InjectableCss;
    largeRow?: InjectableCss;
    smallRow?: InjectableCss;
}

export const countryzoneStyles: CountryZoneStyles = {
    container: {
        css: css`
            display: flex;
            padding: 8px 5px;
            align-items: center;
            width: 100%;
        `,
    },
    largeRow: {
        css: css`
            width: 72%;
        `,
    },
    smallRow: {
        css: css`
            width: 28%;
            padding: 7px 0;
        `,
    },
};

const styles = countryzoneStyles;

type Props = OwnProps;

const CountryZone: FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.largeRow}>
                <Zone contentId={id} zoneName="largeArea" />
            </StyledWrapper>
            <StyledWrapper {...styles.smallRow}>
                <Zone contentId={id} zoneName="smallArea" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const countryzone: WidgetModule = {
    component: CountryZone,
    definition: {
        group: "Common",
        fieldDefinitions: [],
    },
};

export default countryzone;